module.exports = __webpack_public_path__ + "static/screenshot-5-04009cf75f4dde62d58b4eeff5d30462.png";